import {IConfig} from "../../../config";
import {useEffect, useState} from "react";
import {IGlobalConfig} from "../../../App";
import {BrowserRouter, Link, Route, Routes} from "react-router-dom";
import AdminConfigurator from "./configurator/AdminConfigurator";
import VscServerClient, { VscServerClientContext } from "../../../kova/vscServerClient";
import styled from "@emotion/styled/macro";





interface IStationStatus {
    id: string;
    lastActivity:string;
    customer: string | null;
    reservationStatus:string;
    cancelUrl: string|null;
    visualizer:string|undefined;
}
interface IReservationStatus {
    slsOrdId: string;
    expiresIn: string;
    customer:string;
    waitList: string[];
    cancelUrl: string;
}

interface IStatusResponse {
    stations: IStationStatus[];
    reservations: IReservationStatus[];
}
class AdminClient {
    constructor(private readonly endpoint:string, private readonly salesCenterId:string) {}
    async getStatus() {
        const adminRes = await fetch(`${this.endpoint}status`)
        const adminJson = await adminRes.json() as IStatusResponse;
        return adminJson;

    }

}

const AdminDiv = styled.div`

  table {
    border-collapse: collapse;
  }
  th {
    background-color: lightgray;
    border: 1px solid black;
  }
  td {
    border: 1px solid black;
  }
    .reservation {
       background-color:lightgreen; 
    }
`
const AdminLayout = styled.div`


margin:16px;

`;
const Admin: React.FC<{config: IGlobalConfig, serverUri:string, salesCenterId:string}> = ({config, serverUri, salesCenterId}) => {
    const vscServerClient = new VscServerClient(serverUri);
    return <BrowserRouter basename={"/sc/" + salesCenterId + "/admin"}>
        <VscServerClientContext.Provider value={vscServerClient}>
            <AdminLayout>
        <AdminMenu salesCenterId={salesCenterId} />
        <Routes>
            <Route index element={<AdminReservations serverUri={serverUri} salesCenterId={salesCenterId} />}></Route>
            <Route path={"configurator"} element={<AdminConfigurator config={config} serverUri={serverUri} salesCenterId={salesCenterId} />} />


        </Routes>
            </AdminLayout>
        </VscServerClientContext.Provider>
    </BrowserRouter>

}

const AdminMenu: React.FC<{salesCenterId: string}> = (props) => {
    const { salesCenterId } = props;
    return <main>
        <h2>Sales Center {salesCenterId} administration</h2>
        <a href={`/sc/${salesCenterId}`}>Exit admin</a>
        <ul>
            <li>
                <Link to={""}>Status</Link>
            </li>
            <li>
                <Link to={"configurator"}>Sales Center Configurator</Link>
            </li>
        </ul>
    </main>
}
const AdminReservations: React.FC<{serverUri:string, salesCenterId: string}> = (props) => {
    const { salesCenterId, serverUri } = props;
    const adminClient = new AdminClient(serverUri, salesCenterId);
    const [statusResponse, setStatusResponse] = useState<IStatusResponse|null>(null);
    useEffect(() => {
        let stillUpdating = true;
        async function update() {
            try {
                if (!stillUpdating) return;

                const statusResponse = await adminClient.getStatus();
                setStatusResponse(statusResponse);
                if (!stillUpdating) return;

            } finally {
                if (stillUpdating) {
                    setTimeout(update, 1000);
                }
            }
        }
        update();
        return () => { stillUpdating = false; }
    }, [serverUri]);

    if (statusResponse === null) return <div>Loading...</div>;
    function cancel(cancelUrl:string) {
        if (cancelUrl.startsWith("/")) {
            cancelUrl = cancelUrl.substring(1);
        }
        fetch(serverUri + cancelUrl, { method: "POST"});
        setStatusResponse(null); // back to Loading
    }
    return <AdminDiv>
        <h1>VSC back office</h1>
        <h2>Stations</h2>
        <table className={"stations"}><thead><tr>
            <th>Station</th>
            <th>Status</th>
            <th>Last activity</th>
            <th>Customer</th>
            <th colSpan={2}>Reservation</th>
        </tr></thead>
        <tbody>
        { statusResponse.stations.map(station => <tr className={station.reservationStatus !== "" ? "reservation" : "noreservation"}>
            <td>{station.id}</td>
            <td>{station.visualizer}</td>
            <td>{station.lastActivity}</td>
            <td>{station.customer ?? "Not logged in"}</td>
            <td>{station.reservationStatus}

            {station.reservationStatus !== "" && <button onClick={() => cancel(station.cancelUrl!)}>Cancel</button>}</td>

        </tr>) }

        </tbody>
        </table>

        <h2>Reservations</h2>
        <table className={"reservations"}><thead>
        <th>Home</th>
        <th>Expires</th>
        <th>Customer</th>
        <th>Waitlist</th>


        </thead>
        <tbody>
        { statusResponse.reservations.map(reservation => <tr>
            <td>{reservation.slsOrdId}</td>
            <td>{reservation.expiresIn}</td>
            <td>{reservation.customer}
            <button onClick={() => cancel(reservation.cancelUrl)}>Cancel Reservation</button></td>


            <td>{reservation.waitList.join(', ')}</td>

        </tr>) }
        </tbody>
        </table>

    </AdminDiv>
}

export default Admin;